import React from "react";
import PropTypes from 'prop-types';
import {
    Document,
    StyleSheet,
    Font,
    PDFViewer
} from "@react-pdf/renderer";
import font from "../../fonts/ToyotaDisplay-Regular.otf";
import { notArrayOrEmpty } from './../../utils/helpers';
import t from "../../languages/pl";
import RefuelTable from "./RouteSummary/RefuelTable";
import ZoneTable from "./RouteSummary/ZoneTable";
import RoutesTable from "./RouteSummary/RoutesTable";
import IncidentsTable from "./RouteSummary/IncidentsTable";

const classes = StyleSheet.create({
    page: {
        backgroundColor: "#FFF",
        padding: 10
    },
    table: {
        display: "table",
        borderTop: 1,
        borderLeft: 1,
        borderRight: 1,
        borderBottom: 1,
        borderStyle: "solid",
        borderColor: "#000"
    },
    row: {
        display: "flex",
        flexDirection: "row",
        borderBottom: 1,
        borderStyle: "solid",
        borderColor: "#dbd9d9"
    },
    firstRowInPage: {
        marginTop: 10
    },
    headerCell: {
        backgroundColor: "#FAFAFA",
        borderColor: "#000",
        borderStyle: "solid",
        fontWeight: 600
    },
    cell: {
        borderColor: "#000",
        borderStyle: "solid",
        padding: 5,
        display: "flex",
        alignItems: "center",
        justifyContent: 'center',
        flexWrap: "wrap"
    },
    textPrimary: {
        fontFamily: "ToyotaDisplay-Regular",
        fontSize: 10
    },
    textHeader: {
        fontFamily: "ToyotaDisplay-Regular",
        fontSize: 16,
    },
    title: {
        marginTop: 15,
        marginLeft: 15
    }
});

Font.register({family: "ToyotaDisplay-Regular", src: font});

const PdfRouteSummary = props => {
    const { title, routes, refuels, zones, incidents } = props;

    return (
        //left for testing (replace App with PdfRouteSummary in index.js)
        // <PDFViewer width={800} height={1000}>
        <Document>
            {
                !notArrayOrEmpty(routes)
                &&
                <RoutesTable
                    classes={{...classes}}
                    title={title}
                    routes={routes}
                />
            }
            {
                !notArrayOrEmpty(refuels)
                &&
                <RefuelTable
                    classes={{...classes}}
                    title={t.refuels}
                    refuels={refuels}
                />
            }
            {
                !notArrayOrEmpty(zones)
                &&
                <ZoneTable
                    classes={{...classes}}
                    title={t.zoning}
                    zones={zones}
                />
            }
            {
                !notArrayOrEmpty(incidents)
                &&
                <IncidentsTable
                    classes={{...classes}}
                    title={t.incidents}
                    incidents={incidents}
                />
            }
        </Document>
        //   </PDFViewer>
    );
};

PdfRouteSummary.propTypes = {
    routes: PropTypes.array,
    refuels: PropTypes.array,
    zones: PropTypes.array,
    incidents: PropTypes.array,
    title: PropTypes.string
};

export default PdfRouteSummary;